import {User} from '@app/core/models/user.model';
import {RDate} from '@app/core/models/rDate.model';
import {Department} from '@app/core/models/department.model';
import {FileEntry} from '@app/core/models/fileEntry.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {BaseModel} from '@app/core/models/base.model';
import {SupplementalSalary} from '@app/core/models/supplementalSalary.model';

export class Group extends BaseModel {
	public id: string | number; // messageboardposts can contain "d"
	public group_name: string;
	public group_description: string;
	public department: Department;
	public department_name: string;
	public department_id: number;
	public hour_salary: number;
	public available_users: User[];
	public supplemental_salaries: SupplementalSalary[];
	public file_entries: FileEntry[];
	public users: User[];
	public users_count: number;
	public created_at: RDate;
	public updated_at: RDate;
	public deleted_at: RDate;

	public customHourSalary?: number;

	constructor(tenantTZ: string, interService: InternationalizationService) {
		super(tenantTZ, interService);
	}

	public getName(): string {
		return this.group_name;
	}

	public deserialize(input: any): this {
		Object.assign(this, input);
		if (input.users) {
			this.users = [];
			this.users = input.users.map(user => new User(this.tenantTZ, this.interService).deserialize(user));
		}
		if (input.available_users) {
			this.available_users = [];
			this.available_users = input.available_users.map(user => new User(this.tenantTZ, this.interService).deserialize(user));
		}
		if (input.file_entries) {
			this.file_entries = [];
			this.file_entries = input.file_entries.map(user => new FileEntry(this.tenantTZ, this.interService).deserialize(user));
		}
		if (input.supplemental_salaries) {
			this.supplemental_salaries = input.supplemental_salaries.map(supplement => new SupplementalSalary(this.tenantTZ, this.interService).deserialize(supplement));
		}
		if (input.hour_salary) {
			this.hour_salary = parseFloat(input.hour_salary);
		}
		if (input.created_at) {
			this.created_at = new RDate(this.tenantTZ, this.interService).deserialize(input.created_at);
		}
		if (input.department) {
			this.department = new Department(this.tenantTZ, this.interService).deserialize(input.department);
		}
		if (input.updated_at) {
			this.updated_at = new RDate(this.tenantTZ, this.interService).deserialize(input.updated_at);
		}
		if (input.deleted_at) {
			this.deleted_at = new RDate(this.tenantTZ, this.interService).deserialize(input.deleted_at);
		}

		return this;
	}
}
